import { useNavigate } from "react-router-dom";

interface PositionItem {
  name: string;
  code: string;
  price: number;
  cost: number;
  profitRate: number;
  shares: number;
}

interface PositionSnapshotProps {
  positions: PositionItem[];
}

export default function PositionSnapshot({ positions }: PositionSnapshotProps) {
  const navigate = useNavigate();
  return (
    <div className="px-4 mt-3">
      <div className="flex items-center justify-between mb-2">
        <span className="text-sm font-semibold text-foreground-950">持仓快照</span>
        <button onClick={() => navigate("/positions")} className="text-xs text-primary-500 whitespace-nowrap cursor-pointer">全部持仓 →</button>
      </div>
      <div className="flex gap-2 overflow-x-auto scrollbar-hide pb-1">
        {positions.map((pos) => (
          <button key={pos.code} onClick={() => navigate("/positions")}
            className="flex-shrink-0 w-[130px] bg-white rounded-card p-3 text-left cursor-pointer border border-background-200/60">
            <div className="flex items-center justify-between mb-0.5">
              <span className="text-xs font-semibold text-foreground-950 truncate max-w-[80px]">{pos.name}</span>
              <span className={`text-[10px] font-semibold ${pos.profitRate >= 0 ? "text-[#E11D48]" : "text-[#10B981]"}`}>
                {pos.profitRate >= 0 ? "+" : ""}{pos.profitRate.toFixed(1)}%
              </span>
            </div>
            <div className="text-[10px] text-foreground-400">{pos.code}</div>
            <div className="text-sm font-semibold text-foreground-950 mt-1">¥{pos.price.toFixed(2)}</div>
            <div className="text-[10px] text-foreground-400 mt-0.5">{pos.shares}股</div>
          </button>
        ))}
      </div>
    </div>
  );
}
